export const contactLensFlow = {
  entryQuestion: {
    question: "Are you using contact lenses?",
    options: [
      { id: "yes", name: "Yes", sub: "I am already using" },
      { id: "no", name: "No", sub: "I would like to try" },
    ],
  },
  yesBranch: {
    steps: [
      {
        id: "disposabilityCurrent", type: "tabbed", stepLabel: "1/03",
        question: "Which Disposability of Contact lens are you using?",
        tabs: [
          { id: "daily", name: "Daily Disposable" },
          { id: "monthly", name: "Monthly Disposable" },
          { id: "biweekly", name: "Biweekly Disposable" },
        ],
      },
      {
        id: "challenges", type: "multi", stepLabel: "2/03",
        question: "Do you experience any of the following challenges with current contact lenses?",
        options: [
          { name: "Dryness" }, { name: "Discomfort" }, { name: "Irritation" },
          { name: "Redness" }, { name: "Itching" }, { name: "None" },
        ],
      },
      {
        id: "tryAdvanced", type: "single", variant: "text", stepLabel: "3/03",
        question: "Do you want to try advanced lens options?",
        staticOptions: [
          { id: "yes", name: "Yes", sub: "I would like to try new options" },
          { id: "no", name: "No", sub: "I would like to continue with same lenses" },
        ],
      },
    ],
  },
  noBranch: {
    steps: [
      {
        id: "disposabilityDesired", type: "single", variant: "text", stepLabel: "1/02",
        question: "Which Disposability of Contact lens are you looking for?",
        staticOptions: [
          { id: "daily", name: "Daily Disposable" }, { id: "monthly", name: "Monthly Disposable" }, { id: "biweekly", name: "Biweekly Disposable" },
        ],
      },
      {
        id: "hoursWorn", type: "single", variant: "text", stepLabel: "2/02",
        question: "How many hours in a day you want to wear contact lenses?",
        staticOptions: [
          { id: "2-4", name: "2 - 4 hours" }, { id: "6-8", name: "6 - 8 hours" }, { id: "10-12", name: "10 - 12 hours" },
        ],
      },
    ],
  },
  onComplete: "navigateCollection",
};